import { render, staticRenderFns } from "./SectionSearch.vue?vue&type=template&id=3aca1758&"
import script from "./SectionSearch.vue?vue&type=script&lang=js&"
export * from "./SectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports